import React, { useState, useEffect } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import { ListSubheader } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import {
	setState
} from "./fileTransferSlice";

const MultiSelectScenario = (props) => {
  const dispatch = useDispatch();
  const scenariosData = props?.scenariosData;
  let scenarios = scenariosData?.map((item) => item.scenarioName)
  scenarios = scenarios.filter(item => item !== "All");
  const [scenarioName, setScenarioName] = useState([]);
  const [displayItem, setDisplayItem] = React.useState(scenariosData.length - 1);
  const [searchText, setSearchText] = React.useState("");
  const [namesData, setNamesData] = React.useState(scenarios);
  const textInput = React.useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const state = useSelector((store) => store.analyze);

  const {
		selectedproducts,
    clearDataValues,
	} = state;

  const handleChange = (e, name) => {
    dispatch(setState("searchFilterText",""));
    let items = [...scenarioName];
 
    if (e.target.checked) items.push(name);
    else {
      var index = items.indexOf(name);
      items.splice(index, 1);
    }
    setScenarioName(items);
    let itemcount = items.length;
    setDisplayItem(itemcount);
    if (itemcount == 0) {
      setSelectAll(false);
    }
    if (itemcount == scenarios.length) {
      setSelectAll(true);
    }
    else {
      setSelectAll(false);
    }
  };

  useEffect(() => {
    setNamesData(scenarios);
    setSearchText(""); // Reset search text when scenariosData changes
  
    if (scenariosData.length > 0) {
      setSelectAll(true); // Ensure "Select All" is checked
      setScenarioName(scenarios); // Select all scenarios
      setDisplayItem(scenarios.length - 1);
    } else {
      setSelectAll(false);
      setScenarioName([]);
      setDisplayItem(0);
    }
  }, [scenariosData]);


  const handleDelete = (e) => {
    e.preventDefault();
    setScenarioName([]);
    setSelectAll(false);
  };

  const handleInputChange = (value) => {
    setSearchText(value);
  };

  const handleSelectAll = () => {
    let newSelectAll = !selectAll;
    setSelectAll(newSelectAll);

    if (newSelectAll) {
        let selectedItems = searchText
            ? [...new Set([...scenarioName, ...scenarios.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()))])]
            : scenarios;

            setScenarioName(selectedItems);
        setDisplayItem(selectedItems.length - 1);
    } else {
        setScenarioName([]);
        setDisplayItem(0);
    }
};

  useEffect(() => {
    let itemcount = selectedOptions.length - 1;
    setDisplayItem(itemcount);
  }, [selectedOptions])

  useEffect(() => {
    let itemcount = scenarioName.length - 1;
    setDisplayItem(itemcount);
  }, [scenarioName])

  

  useEffect(() => {
    let item = [...namesData];
    item = item.filter((name) => !scenarioName.includes(name));
    if(item.length == 0){
       // setSelectAll(true);
    }
    else{
       //setSelectAll(false);
    }
  }, [namesData]);

  useEffect(() => {
    //use a debounce to delay the search input key entry
    const delayDebounceFn = setTimeout(() => {
      if (searchText) {
        //filter options state using search text provided
        setNamesData((prevVal) => {
          let val = scenarios.filter((name) => name.toLowerCase().includes(searchText.toLowerCase()));

          return val;
        });
      } else {
        setSearchText();
        setNamesData(scenarios);
      }

      //set focus on search text input field on load. setTimeOut is added as textInput is not immediately available
      setTimeout(() => {
        if (textInput.current) textInput.current.focus();
      }, 100);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const getScenarioIdsFromNames = (scanarioNames) => {
    debugger;
    const scenarioIds = scanarioNames.map((name) => {
      const scenario = scenariosData.find((option) => option.scenarioName === name);
      return scenario ? scenario.scenarioID : null;
    });
    return scenarioIds.filter((id) => id !== null);
  };

  useEffect(() => {
      if(scenarioName.length > 0){
        dispatch(setState("selectedScenarioIds", getScenarioIdsFromNames(scenarioName)));
        dispatch(setState("clearDataValues", false));
      }
      else{
        dispatch(setState("selectedScenarioIds", []))
      }
  }, [scenarioName])

  useEffect(() => {
    if (clearDataValues) {
        setScenarioName([]);
      setSelectAll(false);
    }
  }, [clearDataValues])

  return (
    <div>
      <FormControl>
      <InputLabel>Scenario</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          fullWidth
          sx={{
            width: "250px !important",
            height: "44px !important",
          }}
          value={scenarioName}
          //onChange={handleChange}
          size="small"
          input={<OutlinedInput label="MultiSelect" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }} MenuProps>
                 <div>
                 {scenarioName.length === 1 &&(
                    <span>{scenarioName[0]?.substring(0, 15)}</span>
                    )}
                    {scenarioName.length > 1 && (
                      <span>{scenarioName[0]?.substring(0, 15)} +  <b>{displayItem}</b></span>
                  )}
                 <span>
                   <CancelIcon
                     sx={{
                       paddingLeft: "25px",
                       top: "20%",
                       position: "absolute",
                     }}
                     onMouseDown={(e) => {
                       e.stopPropagation();
                       e.preventDefault();
                     }}
                     onClick={(e) => handleDelete(e)}
                   />
                 </span>
               </div>
            </Box>
          )}
        >
          <MenuItem onClick={handleSelectAll}>
            <Checkbox checked={selectAll} />
            <ListItemText primary="Select All" />
          </MenuItem>
          <ListSubheader>
            <TextField
              size="small"
              inputRef={textInput}
              placeholder=""
              //fullWidth
              value={searchText}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  /*close icon to clear the search text*/
                  <InputAdornment position="end">
                    <IconButton onClick={() => setSearchText("")}>
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              onChange={(e) => handleInputChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key !== "Escape") {
                  // Prevents autoselecting item while typing (default Select behaviour)
                  e.stopPropagation();
                }
              }}
            />
          </ListSubheader>
          {namesData?.map((name, index) => (
            <MenuItem key={index + name} value={name}>
              {selectAll ? <Checkbox  onChange={(e) => handleChange(e, name)}
                checked={scenarioName.some((o) => o === name)}
              /> :
                <Checkbox  onChange={(e) => handleChange(e, name)}
                checked={scenarioName.indexOf(name) > -1} />}
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default MultiSelectScenario